import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-information-line"></i>
            <span>平台介绍</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {aboutData.title}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-xl p-6 md:p-8">
            {aboutData.paragraphs.map((p, idx) => (
              <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 last:mb-0">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}